import { useCallback, useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router';
import { StreamingStatusForm } from './StreamingStatusForm/StreamingStatusForm';
import { StreamingStatusList } from './StreamingStatusList/StreamingStatusList';
import { useCallAPI } from 'hooks/useCallAPI';
import {
  DefaultStreamingStatusManager,
  StreamingStatusManager
} from 'core/streamingStatus/StreamingStatusManager';
import { StreamingStatusDTO } from 'core/streamingStatus/StreamingStatus';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import {
  useStreamingStatusCreateFormModel,
  useStreamingStatusEditFormModel
} from './StreamingStatusForm/StreamingStatusFormModel';

const manager: StreamingStatusManager = new DefaultStreamingStatusManager();

export const StreamingStatus: React.FC = () => {
  const { loading, callAPIs } = useCallAPI();
  const [streamingStatusList, setStreamingStatusList] = useState<
    StreamingStatusDTO[]
  >([]);

  const location = useLocation<{ needRefresh?: boolean }>();
  const needRefresh = location.state?.needRefresh;

  useEffect(() => {
    callAPIs([() => manager.getStreamingStatusList()], setStreamingStatusList);
  }, [needRefresh, callAPIs]);

  const renderCreateForm = useCallback(() => {
    return (
      <StreamingStatusForm
        streamingStatusList={streamingStatusList}
        useModel={useStreamingStatusCreateFormModel}
      />
    );
  }, [streamingStatusList]);

  const renderEditForm = useCallback(() => {
    return (
      <StreamingStatusForm
        streamingStatusList={streamingStatusList}
        useModel={useStreamingStatusEditFormModel}
      />
    );
  }, [streamingStatusList]);

  const renderList = useCallback(() => {
    return <StreamingStatusList streamingStatusList={streamingStatusList} />;
  }, [streamingStatusList]);

  return (
    <>
      {loading && <LoadingIndicator />}
      <Switch>
        <Route
          path={'/system/streaming-status/new'}
          render={renderCreateForm}
        />
        <Route
          exact
          path={'/system/streaming-status/:crid/edit'}
          render={renderEditForm}
        />
        <Route render={renderList} />
      </Switch>
    </>
  );
};
